module.exports = __webpack_public_path__ + "img/about1.e65f3260.png";